
const WIDTH = 1380

export default {
  mounted() {
    this.calculateWith()
    window.addEventListener("resize", this.calculateWith, {passive: true})
    setTimeout(() => this.calculateWith(), 100)
    
    const handle = this.$refs.handle
    handle.addEventListener("pointerdown", this.mouseDown, {passive: true})
    window.addEventListener("pointerup", this.pointerUp, {passive: true})

    this.marginLeft = this.$refs.iframe.getBoundingClientRect().left
  },
  beforeDestroy() {
    const handle = this.$refs.handle
    handle.removeEventListener("pointerdown", this.mouseDown)
    window.removeEventListener("pointerup", this.pointerUp)
    window.removeEventListener("mousemove", this.mouseMove)
    window.removeEventListener("resize", this.calculateWith)
  },
  data() {
    return {
      totalWidth: 0,
      width: WIDTH,
      marginLeft: 0,
      moving: false,
    }
  },
  methods: {
    calculateWith() {
      this.totalWidth = this.$el.getBoundingClientRect().width
    },
    mouseDown() {
      this.moving = true
      window.addEventListener("mousemove", this.mouseMove, {passive: true})
    },
    pointerUp() {
      this.moving = false
      this.currentClientWidth = this.clientWidth
      window.removeEventListener("mousemove", this.mouseMove)
    },
    mouseMove(evt) {
      let width = evt.clientX - this.marginLeft
      if (width < 350) width = 350
      const clientWith = this.getSidebarWidth(width, this.totalWidth)
      if (clientWith < 400) width = this.totalWidth - 400
      
      this.width = width
    },

    getSidebarWidth(width, totalWidth) {
      return totalWidth - width
    },
  },
  computed: {
    clientWidth() {
      return this.getSidebarWidth(this.width, this.totalWidth)
    },
  },
}
